<h3>Viele Dank für die Erstellung einer {{art}}!</h3>
<p>Sie ist nun freigeschaltet.</p>
<button  class="btn mat-button" [routerLink]="['/anzeigen-detail', kaid]">Weiter zum Eintrag</button>